import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'Douleutaras/redux/store';
import { JSONApiDataObject, ReduxEntity } from 'Douleutaras/types';
import { makeRequest } from 'Douleutaras/services/apiClient';

export const getAutoDealsEndpoint = (jobId: string) => `api/public/job/${jobId}/autodeals`;

const autoDealsAdapter = createEntityAdapter<JSONApiDataObject<{}>>();

export const fetchAutoDeals = createAsyncThunk(
  'autodeals/get',
  async ({ jobId, email }: { jobId: string, email?: string } = undefined, api) => {

    const response = await makeRequest(
      `${getAutoDealsEndpoint(jobId)}/`,
      {
        additionalGetParams: {
          format: 'json',
          email
        }
      }
    )(api);

    return response.data;
  });

export const autoDealsSlice = createSlice({
  name: 'autoDeals',
  initialState: autoDealsAdapter.getInitialState({
    loading: false,
    error: false,
    entities: {}
  } as ReduxEntity<JSONApiDataObject<{}>>),
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchAutoDeals.fulfilled, (state, action) => {
      state.entities = action.payload;
    });
  }
});

export const autoDealsSelector = autoDealsAdapter.getSelectors((state: RootState) => state.autoDeals);
